import i18n from "src/i18n";
import "./languageSelect.scss";

const LANGUAGES = [
    { code: "de", label: "DE" },
    { code: "en", label: "EN" },
];

export default function LanguageSelect() {
    const current = i18n.language.split("-")[0];

    const change = (code: string) => {
        i18n.changeLanguage(code);
        localStorage.setItem("lang", code);
    };

    return (
        <div className="lang-select">
            {LANGUAGES.map((lang) => (
                <button
                    key={lang.code}
                    className={`lang-select__btn${current === lang.code ? " lang-select__btn--active" : ""}`}
                    onClick={() => change(lang.code)}
                >
                    {lang.label}
                </button>
            ))}
        </div>
    );
}
